export class CostingDestinationReq{
    enquiryid:number
    destinationId:number

    constructor(enquiryid:number,destinationId:number){
        this.destinationId=destinationId
        this.enquiryid=enquiryid

    }
}